export default __webpack_public_path__ + "static/media/logo.38878c57.png";